import React, { useContext, useEffect, useState } from 'react';
import OfferBanner from '../OfferBanner';
import { TabContentWrapper } from '../UI/styledConstants';
import { getAepsBankList, instantpayBalanceEnquiry, instantpayCashwithdrawal, instantpayMerchantLoginFingerprient, instantpayMiniStatement } from '../../utils/api';
import { overLayers, isEmpty, getLocation } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import AepsReceipt from './AepsReceipt';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import { CaptureFingerData, checkLoginStatus, initialControls } from './instantPay';
import SelectDeviceType from './SelectDeviceType';
import CaptureFingerprint from './CaptureFingerprint';
import TransactionScreen from './TransactionScreen';
import { convertXmlToJs, useAepsFingerprint } from '../Sendmoney/useAepsFingerprint';



export default function InatantPayAEPS({ className = '' }) {
	const [bankList, setBankList] = useState(null);
	const [filterBankList, setFilterBankList] = useState(null);
	const [bankDataResp, setBankDataResp] = useState({});
	const [dropDown, setDropdown] = useState(false);
	const [searchKey, setSearchKey] = useState('');
	const [message, setMessage] = useState({});

	const [controls, setControls] = useState({ ...initialControls });

	const [overLayer, setOverLayer] = useState(false);
	const [loading, setLoading] = useState(false);

	//
	const [aepsStatus, setAepsStatus] = useState('TRANSACTION_SCREEN');
	const [deviceType, setDeviceType] = useState('Mantra');
	const [fingerprintLoader_, setFingerprintLoader] = useState(false);
	const { setRefresh, refresh, geolocation, setGeolocation, setAlert } = useContext(GlobleContaxt);
	//
	const number = /^[0-9]+$/;
	const nameReg = /^[A-Za-z\s]+$/i;

	const dType = localStorage.getItem('InstantPaydeviceType');
	useEffect(() => {
		if (dType) {
			setDeviceType(dType);
		}
	}, [dType]);

	const onChangeHandler = (e) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setMessage({ type: 'error', msg: 'Please login first to continue', place: 'globle' });
			return;
		}
		if (e.target.name === 'amount' || e.target.name === 'aadharNumber' || e.target.name === 'mobileNumber') {
			if (!number.test(e.target.value) && e.target.value) {
				return false;
			}
		}

		setControls({
			...controls,
			[e.target.name]: e.target.value,
		});

		if (e.target.name === 'bank') {
			setDropdown(false);
			setSearchKey(e.target?.nextElementSibling?.innerHTML);
		}
	};

	const onSubmitHandler = () => {
		if (controls.mobileNumber === '' || controls.mobileNumber === '' || controls.transactionType === '' || controls.bank === '') {
			setMessage({ type: 'error', msg: 'All field are required', place: 'form' });

			return;
		} else if (controls.mobileNumber.length !== 10) {
			setMessage({ type: 'error', msg: 'Enter 10 digit mobile number', place: 'form' });

			return;
		} else if (controls.aadharNumber.length !== 12) {
			setMessage({ type: 'error', msg: 'Enter 12 digit aadhar number', place: 'form' });

			return;
		} else if (controls.transactionType === 'Withdrawal' && controls.amount < 1) {
			setMessage({ type: 'error', msg: 'Enter Amount', place: 'form' });

			return;
		}

		if (isEmpty(geolocation?.latitude)) {
			setAlert({ type: 'warning', msg: 'Please allow access to your location' });
			getLocation().then((position) => {
				setGeolocation(position);
				if (controls.transactionType === 'Withdrawal') {
					setAepsStatus('CAPTUR_MERCHANT_FOR_TXN');
				} else {
					setAepsStatus('CAPTUR_CUSTOMER');
				}
			});

			return;
		} else {
			if (controls.transactionType === 'Withdrawal') {
				setAepsStatus('CAPTUR_MERCHANT_FOR_TXN');
			} else {
				setAepsStatus('CAPTUR_CUSTOMER');
			}
		}
	};

	useEffect(() => {
		getAepsBankList().then((res) => {
			if (res?.data) {
				setBankList(res?.data);
			}
		});
		checkLoginStatus(setAlert, setLoading, setAepsStatus);
	}, []);

	const handleFilter = (event) => {
		if (isEmpty(localStorage.getItem('ID Token'))) {
			setAlert({ type: 'error', msg: 'Please login first to continue', place: 'globle' });
			return;
		}
		if (bankList) {
			const keyword = event.target.value;
			if (!nameReg.test(keyword) && keyword) {
				return false;
			}

			setSearchKey(keyword.toUpperCase());

			const pattern = new RegExp('^' + keyword, 'i');
			const filtered = bankList.filter((item, index) => {
				return pattern.test(item.bankName);
			});

			if (keyword) {
				setFilterBankList(filtered.slice(0, 4));
			} else {
				setFilterBankList(null);
			}
		}
	};

	function closePop() {
		if(controls.transactionType === "Withdrawal"){
			setRefresh(!refresh);
		}
		setOverLayer(false);
		setBankDataResp({});
		setLoading(false);
		overLayers(false);
		setSearchKey('');
		setMessage({});
		setAepsStatus('TRANSACTION_SCREEN');
		setControls({ ...initialControls });
	}

	useEffect(() => {
		if (!isEmpty(message)) {
			setTimeout(() => {
				setMessage({});
			}, 5000);
		}
	}, [message]);

	const merchantFingerPrient = (fingerPrirntData) => {
		const data = {
			biometricData: fingerPrirntData,
			latitude: geolocation.latitude.toFixed(4),
		   longitude: geolocation.longitude.toFixed(4),
			
		};
		setLoading(true);
		instantpayMerchantLoginFingerprient(data).then((resp) => {
			setLoading(false);
			if (resp?.success) {
				setAlert({ type: 'success', msg: 'Merchant Login successfull You can continue', place: 'globle' });
				if (aepsStatus === 'CAPTUR_FOR_LOGIN') {
					setAepsStatus('TRANSACTION_SCREEN');
				} else {
					setAepsStatus('CAPTUR_CUSTOMER');
				}
			} else {
				if (aepsStatus !== 'CAPTUR_FOR_LOGIN') {
					closePop();
				}
				if (resp?.errorCodeList.length > 0) {
					setAlert({ type: 'error', msg: resp?.errorCodeList[0], place: 'globle' });
				} else {
					setAlert({ type: 'error', msg: resp?.msg, place: 'globle' });
				}
			}
		});
	};

	const { captureFingerprint, loading:fingerprintLoader } = useAepsFingerprint("");

	async function CaptureData(type) {
		if (isEmpty(geolocation?.latitude)) {
			setAlert({ type: 'warning', msg: 'Please allow access to your location '  });
			return;
		}

		try {
			const data = await captureFingerprint("");

      if(!data) return;

	  	convertXmlToJs(data).then((result) => {
						 const qscore = result?.PidData?.Resp[0]?.$.qScore;
												let abc = qscore.replace('\n', '');
												let resp_ = result?.PidData?.Resp[0]?.$;
												resp_ = { ...resp_, qScore: abc };
												if (isEmpty(resp_?.iCount)) {
													resp_.iCount = '0';
												}
												if (isEmpty(resp_?.pgCount)) {
													resp_.pgCount = '';
												}
												if (isEmpty(resp_?.pTimeout)) {
													resp_.pTimeout = '';
												}
												if (isEmpty(resp_?.pCount)) {
													resp_.pCount = '0';
												}
							const fingerPrirntData = {
								errInfo: result?.PidData?.Resp[0]?.$?.errInfo,
								errorCode: result?.PidData?.Resp[0]?.$?.errCode,
								message: 'FingerPrint Scanned Successfully',
								pidDataJson: {
									PidData: {
										Data: {
											content: result?.PidData?.Data[0]?._,
											type: result?.PidData?.Data[0]?.$?.type,
										},
										DeviceInfo: {
											additional_info: {
												Param: [
													{
														name: 'serial_number',
														value: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
													},
													{
														name: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
														value: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
													},
												],
											},
											dc: result?.PidData?.DeviceInfo[0]?.$?.dc,
											dpId: result?.PidData?.DeviceInfo[0]?.$?.dpId,
											mc: result?.PidData?.DeviceInfo[0]?.$?.mc,
											mi: result?.PidData?.DeviceInfo[0]?.$?.mi,
											rdsId: result?.PidData?.DeviceInfo[0]?.$?.rdsId,
											rdsVer: result?.PidData?.DeviceInfo[0]?.$?.rdsVer,
										},
										Hmac: result?.PidData?.Hmac[0],
										Resp: resp_,
										Skey: {
											ci: result?.PidData?.Skey[0]?.$.ci,
											content: result?.PidData?.Skey[0]?._,
										},
									},
								},
								pidDataXML: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + data,
							};
	  
							if (type === 'customer') {
								setLoading(true);
								const param = {
									mobileNumber: controls.mobileNumber,
									bankIIN: controls.bank,
									adhaarNumber: controls.aadharNumber,
									amount: 0,
									pid_xml_base64e: '',
									externalRef: '',
									latitude: geolocation.latitude.toFixed(4),
									longitude: geolocation.longitude.toFixed(4),
									pid_xml_base64e: fingerPrirntData,
								};
								if (controls.transactionType === 'Withdrawal') {
									param.amount = controls.amount;
									instantpayCashwithdrawal(param).then((res) => {
										setLoading(false);
										if (res?.data) {
											setOverLayer(true);
											overLayers(true);
											setBankDataResp(res.data);
										} else {
											closePop();
											if (res?.errorCodeList.length > 0) {
												setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
											} else {
												setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
											}
										}
									});
								}
	  
								if (controls.transactionType === 'enquiry') {
									instantpayBalanceEnquiry(param).then((res) => {
										setLoading(false);
										if (res?.data) {
											setControls({ ...initialControls });
											setOverLayer(true);
											overLayers(true);
											setBankDataResp(res.data);
										} else {
											closePop();
											if (res?.errorCodeList.length > 0) {
												setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
											} else {
												setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
											}
										}
									});
								}
	  
								if (controls.transactionType === 'statement') {
									instantpayMiniStatement(param).then((res) => {
										setLoading(false);
										if (res?.data) {
											setControls({ ...initialControls });
											setOverLayer(true);
											overLayers(true);
											setBankDataResp(res.data);
										} else {
											closePop();
											if (res?.errorCodeList.length > 0) {
												setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
											} else {
												setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
											}
										}
									});
								}
							} else {
								merchantFingerPrient(fingerPrirntData);
							}
						
					});

	  

		} catch (error) {
			
		}
		// CaptureFingerData(
		// 	type,
		// 	deviceType,
		// 	aepsStatus,
		// 	setBankDataResp,
		// 	overLayers,
		// 	setOverLayer,
		// 	setControls,
		// 	setFingerprintLoader,
		// 	controls,
		// 	setAepsStatus,
		// 	setAlert,
		// 	setLoading,
		// 	geolocation,
		// 	closePop
		// );
	}

	const capturArr = ['CAPTUR_FOR_LOGIN', 'CAPTUR_MERCHANT_FOR_TXN', 'CAPTUR_CUSTOMER'];
	return (
		<TabContentWrapper className={`tab-content-wrapper ${className}`}>
			{aepsStatus === 'TRANSACTION_SCREEN' && (
				<TransactionScreen
					controls={controls}
					onChangeHandler={onChangeHandler}
					filterBankList={filterBankList}
					setDropdown={setDropdown}
					dropDown={dropDown}
					message={message}
					setMessage={setMessage}
					onSubmitHandler={onSubmitHandler}
					handleFilter={handleFilter}
					searchKey={searchKey}
					setAepsStatus={setAepsStatus}
				/>
			)}
			{(aepsStatus == 'SELECT_DEVICE_FOR_LOGIN' || aepsStatus == 'SELECT_DEVICE') && (
				<SelectDeviceType setDeviceType={setDeviceType} deviceType={deviceType} setAepsStatus={setAepsStatus} aepsStatus={aepsStatus} />
			)}
			{capturArr.includes(aepsStatus) && <CaptureFingerprint aepsStatus={aepsStatus} fingerprintLoader={fingerprintLoader} Capture={CaptureData} />}

			<div className="tab-content-right">{!loading && <OfferBanner />}</div>

			{loading && <Loader />}
			{overLayer && <AepsReceipt closePop={closePop} transactionType={controls.transactionType} bankDataResp={bankDataResp} />}
		</TabContentWrapper>
	);
}
